// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          lineHeight: "normal",
        },
        gutterBottom: {
          marginBottom: 12,
        },
      },
    },
  };
}
